import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PractitionerOnboarding } from '@/components/onboarding/PractitionerOnboarding';
import { InstructorOnboarding } from '@/components/onboarding/InstructorOnboarding';
import { pushEvent as gtmPushEvent } from '@/integrations/analytics/gtm';
import { GTM_REGISTRATION_COMPLETE } from '@/integrations/analytics/events';
import {
  readPendingOnboarding,
  markOnboardingPending,
  clearPendingOnboarding,
  type PendingOnboarding as OnboardingState,
} from '@/features/onboarding/pendingOnboarding';

const Onboarding = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const stateFromRouter = location.state as OnboardingState | null;

  useEffect(() => {
    if (stateFromRouter) {
      markOnboardingPending(stateFromRouter);
    }
  }, []);

  const state: OnboardingState | null = stateFromRouter ?? readPendingOnboarding();

  if (!state) {
    navigate('/home', { replace: true });
    return null;
  }

  const handleComplete = (destination = '/home') => {
    // Fire the ad-conversion only the first time the user completes onboarding
    // in this session; the pending flag is the dedupe signal.
    if (readPendingOnboarding()) {
      gtmPushEvent(GTM_REGISTRATION_COMPLETE);
    }
    clearPendingOnboarding();
    navigate(destination, { replace: true });
  };

  if (state.isInstructor) {
    return (
      <div className="min-h-screen bg-sossiety-dark">
        <InstructorOnboarding username={state.username} onComplete={handleComplete} />
      </div>
    );
  }

  return (
    <div className="bg-sossiety-dark">
      <PractitionerOnboarding username={state.username} onComplete={handleComplete} />
    </div>
  );
};

export default Onboarding;
